import { atom } from 'recoil';

export const menuListState = atom({
  key: 'menuListState',
  default: [],
});
